import { render } from "./pie_chart_3.svg?vue&type=template&id=787bafae"
const script = {}
script.render = render

export default script